export const isTwelveHourTime = groups => /[a-z]/i.test(groups[groups.length - 1]);

/* eslint-disable no-param-reassign */
/* eslint-disable no-use-before-define */
export const replaceCharAt = (str, index, replacement) => {
    str = str.split('');
    str[index] = replacement;
    return str.join('');
};

export const getGroupId = (index) => {
    if (index < 3) return 0;
    if (index < 6) return 1;
    if (index < 9) return 2;
    if (index < 13) return 3;
    return 4;
};

export const getGroups = str => str.split(/[:\s+]/);

export const zeroPad = (val, digits) => {
    while (val.length < digits) val = `0${val}`;
    return val;
};

export const getBase = (groupId, twelveHourTime) => {
    if (!groupId) return twelveHourTime ? 12 : 24;
    if (groupId < 3) return 60;
    return 1000;
};

export const stringify = (groups) => {
    if (isTwelveHourTime(groups)) return `${groups.slice(0, -1).join(':')} ${groups[groups.length - 1]}`;
    return groups.join(':');
};

export const toggle24Hr = (groups) => {
    const m = groups[groups.length - 1].toUpperCase();
    groups[groups.length - 1] = m === 'AM' ? 'PM' : 'AM';
    return groups;
};

export const adder = (str, groupId, amount) => {
    const groups = getGroups(str);
    const twelveHourTime = isTwelveHourTime(groups);
    if (twelveHourTime && groupId === groups.length - 1) return stringify(toggle24Hr(groups));
    return stringify(add(groups, groupId, amount, twelveHourTime));
};

export const caret = {
    start(el) {
        return el.selectionStart;
    },
    end(el) {
        return el.selectionEnd;
    },
    set(el, start, end) {
        el.setSelectionRange(start, end || start);
    }
};

export const validate = val =>
    /^[0-2][0-9]:[0-5][0-9](:[0-5][0-9](:[0-9][0-9][0-9])?)?(\s+[ap]m)?$/i.test(val);

const replace = (groups, groupId, amount) => {
    const digits = groups[groupId].length;
    groups[groupId] = zeroPad(String(amount), digits);
    return groups;
};

const add = (groups, groupId, amount, twelveHourTime) => {
    const base = getBase(groupId, twelveHourTime);
    if (!groupId && groups[groupId] === '12' && twelveHourTime) groups[groupId] = '00';
    const val = Number(groups[groupId]) + amount;
    groups = replace(groups, groupId, (val + base) % base);
    if (groupId && val >= base) return add(groups, groupId - 1, 1, twelveHourTime);
    if (groupId && val < 0) return add(groups, groupId - 1, -1, twelveHourTime);
    if (!groupId && twelveHourTime) {
        if (val >= base || val < 0) toggle24Hr(groups);
        if (groups[0] === '00') groups[0] = '12';
    }
    return groups;
};



// WEBPACK FOOTER //
// ./src/services/timeInputUtils/index.js